import { useParams } from 'react-router-dom'
import { IconPaths } from '_metronic/helpers'
import { Button, useModal } from 'app/components'
import { EmpresaValoresModal } from '../modal/EmpresaValoresModal'

export const EmpresaValoresListToolbar = () => {
  const { showModal } = useModal()
  const { id } = useParams<{ id: string }>()

  const openModal = () =>
    showModal({ title: 'Cadastrar valor', content: <EmpresaValoresModal idEmpresa={Number(id)} /> })

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openModal}>
      Novo valor
    </Button>
  )
}
